module.exports = __webpack_public_path__ + "static/media/icon-warning.958307dc.svg";